"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNamedComponent = void 0;
const react_1 = require("react");
function isNamedComponent(element, name) {
    return ((0, react_1.isValidElement)(element) &&
        typeof element.type === 'function' &&
        element.type.name === name);
}
exports.isNamedComponent = isNamedComponent;
